import React, { useEffect } from "react";
import Header from "../components/header/Header";
import Footer from "../components/footer";
import Gotop from "../components/gotop";
import "./Termsofuse.scss";

function Termsofuse() {
  return (
    <>
      <Header />
      
      <section className="terms-page">
        <div className="terms-content">
            <h1 className="terms-title">Terms and Conditions of Service</h1>
            <p className="terms-last-updated">LAST UPDATED: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>
            
            <div className="terms-intro">
              <p>
                This page describes the Terms and Conditions of Service that govern your use of this website and certain products, 
                site-related services (including the content and code related thereto) offered by Talsolution ("Talsolution" or "Company" 
                or "We" or "Us" or "Our"). We provide this website and all site related services including the content and code related 
                thereto (collectively "Site") subject to your compliance with these Terms and Conditions of Service (the "Agreement").
              </p>
              <p>
                <strong>Service Description:</strong> Talsolution is a free hiring platform that connects global talent candidates with 
                US-based employers. We provide a technology platform for job postings, application submissions, candidate pre-screening, 
                and hiring facilitation. Talsolution is not an employer, recruiter, or employment agency. We do not guarantee employment 
                outcomes, make hiring decisions, or participate in the actual employment relationship between employers and candidates. 
                We are a venue/platform that facilitates connections between candidates and employers.
              </p>
              <p className="terms-warning">
                <strong>READ THIS AGREEMENT CAREFULLY BEFORE USING OUR SITE AS IT WILL IMPACT YOUR LEGAL RIGHTS.</strong>
              </p>
              <p>
                <strong>No Legal, Tax, or Employment Advice:</strong> Nothing on this Site constitutes legal, tax, or employment advice. 
                The information provided on this Site is for general informational purposes only. You should consult with qualified 
                professionals for advice specific to your situation regarding employment, immigration, taxation, or legal matters.
              </p>
            </div>

            <div className="terms-section">
              <h2>1. Legal and General Information</h2>
              
              <h3>1.1</h3>
              <p>This Agreement is made between the Company and you, the Site visitor, and/or registered user, and/or as applicable, the business you represent.</p>
              
              <h3>1.2</h3>
              <p>
                Your use of the Site indicates your consent to be bound by the Agreement. If you are using this Site or its services as 
                the representative of an employer, recruiter, staffing agency, or other business, you represent that you have the authority 
                to bind such employer, recruiter, staffing agency, or other business entity to this Agreement, and that by using the Site 
                or its services, you agree that such employer, recruiter, staffing agency, or other business entity is also bound by this 
                Agreement. If you do not consent to the terms of this Agreement, please do not use the Site.
              </p>
              
              <h3>1.3</h3>
              <p>
                We reserve the right to make changes to this Agreement at any time. Such changes may include, but are not limited to, 
                eliminating or discontinuing content or features of the Site, restricting the hours of availability or amount of permitted 
                use of the Site, changes to the fees associated with use of the Site and/or any of the Site's related features.
              </p>
              
              <h3>1.4</h3>
              <p>
                When any changes to these terms are made, the Company will post the most current version of the Agreement on its website. 
                If a revision to the Agreement is material, Talsolution may notify you of the change via email or other means. If you do not 
                agree with the modified Agreement terms, you should discontinue your use of the Site as your continued use of the Site will 
                be deemed acceptance of such changes. It is your responsibility to review this Agreement periodically to ensure familiarity 
                with the most current version.
              </p>
              
              <h3>1.5</h3>
              <p>You must be at least 18 years of age to use the Site.</p>
            </div>

            <div className="terms-section">
              <h2>2. Ownership; Proprietary Notices</h2>
              
              <h3>2.1</h3>
              <p>
                The Site, including all pages within and all code related thereto, is the property of Talsolution. No portion of the materials 
                or code found anywhere on the Site may be reprinted or republished (other than as is necessary to view the page on your device) 
                in any form without the express written permission of the Company.
              </p>
              
              <h3>2.2</h3>
              <p>
                <strong>TALSOLUTION</strong> is a trademark and/or service mark of the Company. All other trademarks and/or service marks used 
                in this Site are the trademarks and/or service marks of their respective owners. © {new Date().getFullYear()} Talsolution. All Rights Reserved.
              </p>
              
              <h3>2.3</h3>
              <p>
                The Site is owned and operated by Talsolution. Unauthorized use of the materials on the Site may violate copyright, trademark, 
                patent and other laws and is strictly prohibited. You acknowledge that you do not acquire any ownership rights by using the Site.
              </p>
            </div>

            <div className="terms-section">
              <h2>3. Warranty Information; Disclaimer</h2>
              
              <h3>3.1</h3>
              <p>
                <strong>THIS SITE, INCLUDING ANY CONTENT OR INFORMATION CONTAINED WITHIN IT OR ANY SITE RELATED SERVICE, OR ANY PRODUCT OR SERVICE 
                LICENSED, PURCHASED OR OTHERWISE MADE AVAILABLE THROUGH THE SITE, IS PROVIDED "AS IS" WITH NO REPRESENTATIONS OR WARRANTIES OF ANY 
                KIND, EITHER EXPRESSED OR IMPLIED.</strong>
              </p>
              
              <h3>3.2</h3>
              <p>
                TO THE FULLEST EXTENT PERMISSIBLE PURSUANT TO APPLICABLE LAW, TALSOLUTION AND ITS SUBSIDIARIES, AFFILIATES, SUPPLIERS, SPONSORS, 
                AND AGENTS DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF TITLE, 
                MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT.
              </p>
              
              <h3>3.3</h3>
              <p>
                NEITHER TALSOLUTION, ITS SUBSIDIARIES, AFFILIATES, SPONSORS, SUPPLIERS NOR AGENTS MAKES ANY REPRESENTATION AS TO THE RESULTS TO BE 
                OBTAINED FROM USE OF THE SITE OR THE SITE-RELATED SERVICES.
              </p>
              
              <h3>3.4</h3>
              <p>
                TALSOLUTION AND ITS SUBSIDIARIES, AFFILIATES, SUPPLIERS, AND AGENTS DO NOT WARRANT THAT YOUR USE OF THE SITE OR THE SOFTWARE WILL 
                BE UNINTERRUPTED, ERROR-FREE, OR SECURE, THAT DEFECTS WILL BE CORRECTED, OR THAT THE SITE (OR THE SERVER(S) ON WHICH IT IS HOSTED) 
                OR SOFTWARE ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.
              </p>
              
              <h3>3.5</h3>
              <p>
                YOU ACKNOWLEDGE THAT YOU ARE RESPONSIBLE FOR OBTAINING AND MAINTAINING ALL TELEPHONE, COMPUTER HARDWARE AND OTHER EQUIPMENT NEEDED TO 
                ACCESS AND USE THE SITE, AND ALL CHARGES RELATED THERETO. YOU ASSUME TOTAL RESPONSIBILITY AND RISK FOR YOUR USE OF THE SITE AND 
                THE SOFTWARE AND YOUR RELIANCE THEREON. NO OPINION, ADVICE, OR STATEMENT OF TALSOLUTION OR ITS SUBSIDIARIES, AFFILIATES, SUPPLIERS, 
                AGENTS, REGISTERED USERS, OR VISITORS, WHETHER MADE ON THE SITE, OR OTHERWISE, SHALL CREATE ANY WARRANTY. 
                <strong>YOUR USE OF THE SITE AND ANY MATERIALS PROVIDED THROUGH THE SITE ARE ENTIRELY AT YOUR OWN RISK.</strong>
              </p>
              
              <h3>3.6</h3>
              <p>
                You acknowledge that the Site could include inaccuracies, errors, or materials that violate the "Code of Conduct" found in Section 8 below. 
                Additionally, you acknowledge that unauthorized additions, deletions, and alterations could be made by third parties to the Site. Although 
                the Company attempts to ensure the integrity and the accuracy of the Site, it makes no guarantees whatsoever as to the Site's completeness 
                or correctness. In the event you believe the site to contain inaccuracies or errors, please contact us at 
                <a href="mailto:legal@talsolution.com"> legal@talsolution.com</a> with, if possible, a description of the material to be checked and the 
                location (URL) where such material can be found on the Site, as well as information sufficient to enable us to contact you. We will try 
                to address your concerns as soon as reasonably practicable. For copyright infringement claims, see Section 14 below.
              </p>
              
              <h3>3.7</h3>
              <p>
                The Site is a venue allowing for the posting by employers, recruiters, and staffing agencies of available job opportunities at their 
                companies or companies they represent (hereinafter referred to collectively as "Employers") and by candidates of their own resumes and 
                application materials. The Company provides pre-screening and evaluation services for candidates but does not guarantee employment outcomes. 
                Moreover, the Company is not involved in the actual employment transaction, if any, between potential Employers and candidates. Therefore, 
                the Company has no control over the quality, safety, or legality of the job postings by Employers or resumes posted to the Site by candidates, 
                the truth or accuracy of such job listings or resumes, the ability of Employers to hire candidates or the ability of candidates to fill 
                job openings.
              </p>
              <p>
                <strong>Independent Contractor and Employment Classification Disclaimer:</strong> Talsolution does not classify workers and is not 
                responsible for contractor or employment classification decisions. The classification of any relationship between employers and candidates 
                (whether as employee, independent contractor, or other status) is determined solely by the employer and candidate, subject to applicable laws. 
                Talsolution is not a party to any employment or contractor relationship and assumes no responsibility for such classifications or any 
                consequences arising therefrom.
              </p>
              
              <h3>3.8</h3>
              <p>
                Because user authentication on the Internet is difficult, the Company cannot and does not confirm that users are who they claim to be. 
                Because We are not and cannot be involved in user-to-user transactions or control the behavior of the Site's users, in the event that 
                you have a dispute of any kind or nature with one or more Site users, you release Talsolution (and its subsidiaries, affiliates, agents 
                and employees, officers, directors and assigns) from all claims, demands and damages (actual and consequential, direct and indirect) of 
                any kind and nature, known and unknown, suspected and unsuspected, disclosed and undisclosed, arising out of or in any way related to 
                such disputes. You acknowledge that there may be certain risks, including physical harm and dealing with strangers, underage persons or 
                people acting under false pretenses, associated with pursuing relationships begun on the Internet. You assume all risks related to dealing 
                with other users with whom you have had contact through the Site.
              </p>
              
              <h3>3.9</h3>
              <p>
                You acknowledge and agree that you are solely responsible for the form, content and accuracy of any resume, job listing or other material 
                you post to the Site. The Company neither warrants nor guarantees that a resume or job posting will be viewed by any specific number of 
                users, or that a resume or job listing will be viewed by any user. We are not to be considered as an employer with respect to your use 
                of the Site and the Company specifically disclaims any and all responsibility for any employment decisions made by any Employer or any 
                individuals posting resumes to the Site.
              </p>
            </div>

            <div className="terms-section">
              <h2>4. Limitation of Liability</h2>
              <p>
                NEITHER TALSOLUTION NOR ITS SUBSIDIARIES, AFFILIATES, SUPPLIERS, ADVERTISERS, AGENTS OR SPONSORS ARE RESPONSIBLE OR LIABLE FOR ANY INDIRECT, 
                INCIDENTAL, CONSEQUENTIAL, SPECIAL, EXEMPLARY, PUNITIVE OR OTHER DAMAGES UNDER ANY CONTRACT, NEGLIGENCE, STRICT LIABILITY OR OTHER THEORY 
                ARISING OUT OF OR RELATING IN ANY WAY TO THE SITE AND/OR CONTENT CONTAINED ON THE SITE, OR ANY PRODUCT OR SERVICE PURCHASED THROUGH THE 
                SITE. YOUR SOLE REMEDY FOR DISSATISFACTION WITH THE SITE AND/OR CONTENT CONTAINED WITHIN THE SITE IS TO STOP USING THE SITE. THE SOLE 
                AND EXCLUSIVE MAXIMUM LIABILITY TO COMPANY FOR ALL DAMAGES, LOSSES, AND CAUSES OF ACTION (WHETHER IN CONTRACT, TORT, INCLUDING, WITHOUT 
                LIMITATION, NEGLIGENCE OR OTHERWISE) SHALL BE THE TOTAL AMOUNT PAID BY YOU, IF ANY, TO ACCESS THE SITE.
              </p>
            </div>

            <div className="terms-section">
              <h2>5. Acknowledgement</h2>
              <p>
                This Site may contain links to other web sites operated by third parties, other than affiliates of the Company ("Linked Sites"). We 
                neither control nor endorse such other web sites, nor have we reviewed or approved any content that appears on the Linked Sites. 
                You acknowledge that when you click on a link to visit a Linked Site, a frame may appear that contains the Company logo, advertisements 
                and/or other content selected by the Company. You acknowledge that the Company and its sponsors neither endorse nor are affiliated with 
                the Linked Sites and are not responsible for any content that appears on the Linked Sites. You also acknowledge that the owner of the 
                Linked Site neither endorses nor is affiliated with the Company and its sponsors.
              </p>
            </div>

            <div className="terms-section">
              <h2>6. Use of Site Features</h2>
              
              <h3>6.1</h3>
              <p>
                You understand and agree that use of the site and its features is governed by this Agreement. By utilizing site features, you agree that 
                the Company does not assume any responsibility for information that you may enter while utilizing the site tools.
              </p>
              
              <h3>6.2</h3>
              <p>
                You understand and agree that use of Talsolution's services, including application submission and video recording features, is governed 
                by this Agreement. By utilizing these features, you consent to the storage and processing of your application materials, including resumes 
                and video recordings, for the purpose of candidate evaluation and potential employment opportunities.
              </p>
              <p>
                <strong>Video Recording Consent:</strong> When you submit video recordings as part of your application, you explicitly acknowledge and 
                consent that: (a) you are being recorded; (b) your video will be stored on our servers and shared with potential employers; (c) you have 
                the right to be recorded and are providing this content voluntarily; (d) the video may be reviewed by employers, recruiters, and Talsolution 
                staff for evaluation purposes; and (e) you understand that video recordings cannot be easily deleted once shared with employers. By clicking 
                "Submit" or "Looks Good" on any video recording interface, you confirm your explicit consent to these terms.
              </p>
            </div>

            <div className="terms-section">
              <h2>7. Void Where Prohibited; Indemnification</h2>
              
              <h3>7.1</h3>
              <p>
                Although the Site is accessible worldwide, not all products or services discussed, referenced, or made available on the Site are available 
                to all persons or in all geographic locations or jurisdictions. We make no representation that materials in the Site are appropriate or 
                available for use in locations outside the United States. Those who choose to access the Site do so on their own initiative and at their 
                own risk and are responsible for compliance with local laws if and to the extent local laws are applicable. The Company reserves the right 
                to limit the availability of the Site and/or the provision of any product or service described thereon to any person, geographic area, or 
                jurisdiction it so desires at any time and in our sole discretion and to limit the quantities of any such product or service that We provide.
              </p>
              
              <h3>7.2</h3>
              <p>
                You agree to indemnify, defend and hold the Company, our affiliates, sponsors, officers, directors, employees, agents, representatives and 
                assigns harmless from and against any and all claims, damages, losses, costs (including reasonable attorneys' fees), or other expenses that 
                arise directly or indirectly out of or from (a) your breach of this Agreement, (b) your violation of the Code of Conduct contained herein, 
                and/or (c) your activities and use of the Site or Site-related services including Processing of personal data and any hiring or employment 
                decisions made by you or your company.
              </p>
          </div>

            <div className="terms-section">
              <h2>8. Code of Conduct</h2>
              
              <h3>8.1</h3>
              <p>You agree to comply with all applicable laws, rules, and regulations in connection with your use of the Site and Site-related services.</p>
              
              <h3>8.2</h3>
              <p>While using the Site or Site-related services, you agree not to do any of the following without our prior written authorization:</p>
              <ol className="terms-list">
                <li>Post any inaccurate, untimely, stale, incomplete or misleading information.</li>
                <li>Post any employment opportunity or requirements that are inaccurate or not available with a verifiable company that is directly represented by your office.</li>
                <li>Post any employment opportunities that are not legitimate or are fraudulent in nature.</li>
                <li>Post the same position multiple times on the Site or post multiple positions within one posting.</li>
                <li>Place any contact information within a job posting that is different from or in addition to contact information provided when subscribing to the Talsolution service.</li>
                <li>Post any employment opportunity that does not contain a company URL, e-mail address or "apply online" application.</li>
                <li>Resell or make available to any person not expressly licensed by Talsolution, whether via phone, fax, e-mail, mail or any other medium, any of the Talsolution services or any information obtained therefrom, including without limitation candidate information.</li>
                <li>Share passwords, login information or named user identification or otherwise allow multiple offices or users to access the Talsolution service on a basis that is other than what was originally subscribed for.</li>
                <li>Use any search engine, software, tool, electronic storage or retrieval device, agent or other device or mechanism that is not approved by Talsolution to navigate, search or store information from the Site.</li>
                <li>Use the Site or any services or information contained therein or obtained therefrom to directly or indirectly create, train, test, or improve any machine learning, large language or artificial intelligence models or similar or competing products, service or technology.</li>
                <li>Allow job postings or employment requirements to remain posted on the Site for more than 24 hours after they are no longer viable or valid.</li>
                <li>Engage in spamming, flooding, soliciting or mass marketing via e-mail, direct mail, telephone, or otherwise to Talsolution job seekers or subscribers.</li>
                <li>Express or imply that any statements you make are endorsed by Talsolution.</li>
                <li>Impersonate any person or entity, including, without limitation, a Talsolution employee or agent, a user of Talsolution's services, including a candidate, placement specialist or an employer, or otherwise misrepresent your affiliation with any person or entity.</li>
                <li>Respond to a job listing on behalf of anyone other than yourself.</li>
                <li>Delete or revise any material posted by any other person or entity.</li>
                <li>Restrict or inhibit any other user from using and enjoying the Site and services, including, without limitation, by means of "hacking" or defacing any portion of the Site.</li>
                <li>Post or transmit (i) any incomplete, false or inaccurate biographical information or information that is not your own accurate resume; (ii) any content or information that is unlawful, fraudulent, threatening, abusive, libelous, defamatory, obscene or otherwise objectionable or harmful, or that infringes on our or any third party's intellectual property or other rights; (iii) any advertisements, solicitations, chain letters, pyramid schemes, investment opportunities, or other unsolicited commercial communication; (iv) any information or software that contains a virus, worm, Trojan horse or other harmful or disruptive component; (v) any trade secret of any third party; or (vi) any material, nonpublic information about companies without the authorization to do so.</li>
                <li>Post or transmit any job advertisement or posting that does not comply with applicable law, including, but not limited to, United States federal, state and local laws relating to equal employment opportunity and employment eligibility verification.</li>
                <li>Use the Site for any unlawful commercial, research or information gathering purposes.</li>
                <li>Communicate, send, or place unsolicited e-mail, telephone calls, mailings, or other contacts to posting individuals and entities.</li>
                <li>Modify, adapt, sublicense, translate, sell, reverse engineer, decompile or disassemble any portion of the Site.</li>
                <li>Remove any copyright, trademark, or other proprietary rights notices contained in the Site.</li>
                <li>"Frame" or "mirror" any part of the Site.</li>
                <li>Use any robot, spider, site search/retrieval application, or other manual or automatic device or process to retrieve, index, "data mine," or in any way reproduce or circumvent the navigational structure or presentation of the Site or its contents.</li>
                <li>Print out or otherwise copy or use any personally identifiable information about candidates for purposes other than consideration of the candidates for potential employment by your company.</li>
              </ol>
              
              <h3>8.3</h3>
              <p>
                Talsolution assumes no responsibility or liability for any personnel selected by your company. Selection, retention or hire of any individual 
                or entity is based solely on your company's investigation, verification, and determination that such hire is suitable for your company's purposes.
              </p>
              
              <h3>8.4</h3>
              <p>
                The Company has no obligation to monitor the Site or Site-related services, including any forum, or any materials that you or other third 
                parties transmit or post on to the Site. However, you acknowledge and agree that the Company has the right (but not the obligation) to monitor 
                the Site and Site-related services, including any forum, and the materials you transmit or post, to alter or remove any such materials 
                (including, without limitation, any posting to the Site), and to disclose such materials and the circumstances surrounding their transmission 
                to any third party in order to operate the Site properly, to protect itself, its sponsors, its registered users and visitors, and to comply 
                with legal obligations or governmental requests.
              </p>
              
              <h3>8.5</h3>
              <p>
                The Company reserves the right to refuse to post or to remove any information or materials, in whole or in part, that it deems in its sole 
                discretion to be unacceptable, offensive or in violation of this Agreement. The Company also reserves the right to prohibit any user who, 
                in the Company's sole discretion, violates the Code of Conduct or other terms of this Agreement from using the Site and related services. 
                Such prohibition may occur without notice to the user.
              </p>
            </div>

            <div className="terms-section">
              <h2>9. Compliance with Privacy Laws</h2>
              <p>Talsolution and you shall each comply with all applicable laws and regulations pertaining to data privacy and personal data.</p>
            </div>

            <div className="terms-section">
              <h2>10. Making Purchases</h2>
              
              <h3>10.1</h3>
              <p>
                Talsolution is a free platform for candidates. If products or services are made available at the Site for employers or other users, and if 
                you wish to license or make purchases of products or services described on the Site, you may be asked by us or the applicable merchant or 
                service provider to supply certain information, including but not limited to credit card or other information. If you submit such information 
                to us, you understand that any such information will be treated by the Company in the manner described in our Privacy Policy.
              </p>
              
              <h3>10.2</h3>
              <p>
                You agree that all information that you provide to us or any merchant or service provider whose products or services are made available on 
                the Site will be accurate, complete and current. You agree to pay all charges incurred by you or any users of your account at the prices 
                in effect when such charges are incurred. You will also be responsible for paying any applicable taxes relating to your purchases. Moreover, 
                you agree to review and to comply with the terms and conditions of any specific agreement, if any, that you enter into with the merchant 
                and/or service provider in connection with the licensing or purchase of any product or service.
              </p>
                </div>

            <div className="terms-section">
              <h2>11. Submissions</h2>
              
              <h3>11.1</h3>
              <p>
                Because We and Our designees host job boards and other forums found on the Site and elsewhere, We require certain rights in the materials 
                you give us. Therefore, by sending or transmitting to us resources, information, ideas, notes, concepts, trademarks, service marks or other 
                materials (including, but not limited to, job postings, resumes, and video recordings) (collectively, "Content"), or by posting such Content 
                to any area of the Site, you grant the Company and its designees a worldwide, non-exclusive, sub-licensable (through multiple tiers), 
                assignable, royalty-free, perpetual, irrevocable right to link to, reproduce, distribute (through multiple tiers), adapt, create derivative 
                works of, publicly perform, publicly display, digitally perform or otherwise use such Content in any media now known or hereafter developed. 
                Further, you hereby grant the Company permission to display your logo, trademarks and company name on the Site and in press and other public 
                releases or filings. By submitting Content to the Company, you acknowledge that you have the authority to grant such rights to the Company. 
                <strong>PLEASE NOTE THAT YOU RETAIN OWNERSHIP OF ANY COPYRIGHTS, TRADEMARKS AND SERVICE MARKS IN ANY CONTENT YOU SUBMIT.</strong>
              </p>
              
              <h3>11.2</h3>
              <p>
                None of the Content is endorsed by the Company, and the Company cannot and does not make any representations with respect to the truth or 
                reliability of the Content. The Company reserves the right to remove any Content, in whole or in part, from the Site in its sole discretion.
              </p>
              
              <h3>11.3</h3>
              <p>Communications between the Company and the users of the Site are not confidential.</p>
                </div>

            <div className="terms-section">
              <h2>12. Registration; Use of Secure Areas and Passwords</h2>
              
              <h3>12.1</h3>
              <p>
                Some areas of the Site may require you to register with us. When and if you register, you agree to (a) provide accurate, current, and 
                complete information about yourself as prompted by our registration form and (b) to maintain and update your information (including your 
                e-mail address) to keep it accurate, current, and complete. You acknowledge that should any information provided by you be found to be 
                untrue, inaccurate, not current, or incomplete, we reserve the right to terminate this Agreement with you and restrict you from use of 
                the Site.
              </p>
              
              <h3>12.2</h3>
              <p>
                As part of the registration process, your username will be your email address and you will be asked to select a password. In the Company's 
                sole discretion, We may refuse to allow a username that impersonates someone else, may be illegal, may be protected by trademark or other 
                proprietary rights law, is vulgar or otherwise offensive, or may cause confusion.
              </p>
              
              <h3>12.3</h3>
              <p>
                You will be responsible for the confidentiality and use of your password and agree not to distribute, transfer, or resell your use of, or 
                access to, the Site to any third party. If more than one individual wishes to use a single password belonging to a registered user, such 
                registered user must request permission from the Company in writing, it being understood that the Company shall be under no obligation to 
                approve any such request.
              </p>
              
              <h3>12.4</h3>
              <p>
                If you have reason to believe that your account with us is no longer secure, you must promptly change your password by updating your account 
                information and immediately notifying us of the problem via email addressed to <a href="mailto:security@talsolution.com">security@talsolution.com</a>.
              </p>
              
              <h3>12.5</h3>
              <p>
                <strong>YOU ARE SOLELY AND ENTIRELY RESPONSIBLE FOR MAINTAINING THE CONFIDENTIALITY OF YOUR USERNAME AND PASSWORD AND SOLELY AND ENTIRELY 
                RESPONSIBLE FOR ANY AND ALL ACTIVITIES THAT ARE CONDUCTED THROUGH YOUR ACCOUNT.</strong>
              </p>
            </div>

            <div className="terms-section">
              <h2>13. Termination</h2>
              
              <h3>13.1 Termination by You</h3>
              <p>
                You may stop using the Site at any time. You may also request deletion of your account and associated data by contacting us at 
                <a href="mailto:privacy@talsolution.com"> privacy@talsolution.com</a>. We will process your deletion request in accordance with our 
                Privacy Policy and applicable law.
              </p>
              
              <h3>13.2 Termination by Talsolution</h3>
              <p>
                We reserve the right, in our sole discretion, to suspend or terminate your access to the Site and services at any time, with or without 
                notice, for any reason, including but not limited to:
              </p>
              <ul className="terms-list">
                <li>Violation of this Agreement or our Code of Conduct</li>
                <li>Fraudulent, abusive, or illegal activity</li>
                <li>Misrepresentation of your identity or qualifications</li>
                <li>Posting false, misleading, or inappropriate content</li>
                <li>Violation of any applicable laws or regulations</li>
                <li>Any other conduct that we determine, in our sole discretion, harms our users, our business, or violates the spirit of this Agreement</li>
              </ul>
              
              <h3>13.3 Effect of Termination</h3>
              <p>
                Upon termination of your access: (a) your right to use the Site will immediately cease; (b) we may delete or disable your account 
                and all associated content; and (c) we are not obligated to retain, store, or provide you with any data, content, or other information 
                that was associated with your account. Sections of this Agreement that by their nature should survive termination will survive, 
                including but not limited to ownership provisions, warranty disclaimers, indemnity, and limitations of liability.
              </p>
          </div>

            <div className="terms-section">
              <h2>14. DMCA Notice</h2>
              <p>
                The Digital Millennium Copyright Act of 1998 (the "DMCA") provides recourse for copyright owners who believe that material appearing on 
                the Internet infringes their rights under U.S. copyright law.
              </p>
              <p>If you have a good faith belief that materials hosted by us infringe your copyright, please provide the following written information to the Company's designated copyright agent:</p>
              <ol className="terms-list">
                <li>An electronic or physical signature of the person authorized to act on behalf of the owner of the copyright interest;</li>
                <li>A description of the copyrighted work that you claim has been infringed upon;</li>
                <li>A direct link to or a full description of location of the infringing material located on the Site;</li>
                <li>Your address, telephone number and email address;</li>
                <li>A statement by you that you have a good faith belief that the disputed use is not authorized by the copyright owner, its agent or the law;</li>
                <li>A statement by you, made under penalty of perjury, that the above information in your notice is accurate and that you are the copyright owner or authorized to act on the copyright owner's behalf.</li>
              </ol>
              <p>
                Notices and counter-notices must meet the then-current statutory requirements imposed by the DMCA; see 
                <a href="http://www.loc.gov/copyright/" target="_blank" rel="noopener noreferrer"> http://www.loc.gov/copyright/</a> for details. 
                Notices and counter-notices with respect to the Site should be sent to:
              </p>
              <div className="terms-contact">
                <p><strong>Attention: Legal Department</strong></p>
                <p>Talsolution</p>
                <p>2821 Mexico Gravel Rd #5 Columbia MO 65202</p>
                <p>Email: <a href="mailto:legal@talsolution.com">legal@talsolution.com</a></p>
              </div>
            </div>

            <div className="terms-section">
              <h2>15. Miscellaneous</h2>
              
              <h3>15.1</h3>
              <p>
                This Agreement is entered into in the State of Missouri and shall be governed by and construed in accordance with the laws of the State of 
                Missouri, exclusive of its choice of law rules. Each party to this Agreement hereby submits to the exclusive jurisdiction of the state and 
                federal courts sitting in the County of Boone in the State of Missouri for any dispute arising under or in connection with this Agreement, 
                the Site or any Site-related services, and waives any jurisdictional, venue or inconvenient forum objections to such courts. In any action 
                to enforce this Agreement, the prevailing party will be entitled to costs and attorneys' fees.
              </p>
              
              <h3>15.2</h3>
              <p>
                In the event that any of the provisions of this Agreement shall be held by a court or other tribunal of competent jurisdiction to be unenforceable, 
                such provisions shall be limited or eliminated to the minimum extent necessary so that this Agreement shall otherwise remain in full force and 
                effect and enforceable. Failure of any party to insist upon strict compliance with any of the terms and conditions of this Agreement shall not 
                be deemed a waiver or relinquishment of any similar right or power at any subsequent time.
              </p>
              
              <h3>15.3</h3>
              <p>
                This Agreement constitutes the entire agreement between the parties hereto pertaining to the subject matter hereof, and any and all written or 
                oral agreements previously existing between the parties are expressly canceled.
              </p>
              
              <h3>15.4</h3>
              <p>
                This Agreement is not assignable, transferable or sub-licensable by you except with prior written consent of the Company. Any heading, caption 
                or section title contained in this Agreement is inserted only as a matter of convenience and in no way defines or explains any section or 
                provision hereof. The Company reserves the right in its sole discretion to terminate the use of the Site by a user at any time.
              </p>
              
              <h3>15.5</h3>
              <p><strong>Notice.</strong> Any notice under these Terms and Conditions will be deemed to have been sufficiently given and received for all purposes when delivered confirmed electronic transmission, or nationally recognized overnight courier, or five days after being sent by certified or registered mail, postage and charges prepaid, return receipt requested, to the address or e-mail address identified below.</p>
              <div className="terms-contact">
                <p><strong>Address:</strong></p>
                <p>Talsolution</p>
                <p>2821 Mexico Gravel Rd #5 Columbia MO 65202</p>
                <p><strong>ATTN: Legal</strong></p>
                <p>Email: <a href="mailto:legal@talsolution.com">legal@talsolution.com</a></p>
              </div>
            </div>

            <div className="terms-section">
              <h2>16. Legal Notices</h2>
              <p>Under California Civil Code Section 1789.3, California residents are entitled to the following specific consumer rights information:</p>
              <p>
                <strong>Pricing Information:</strong> Talsolution is a free platform for candidates. Current rates for employer services, if any, may be obtained 
                by calling us or by sending an e-mail to the Talsolution Sales Department. We reserve the right to change fees, surcharges, monthly or other 
                periodic subscription fees or to institute new fees at any time as provided in this Agreement.
              </p>
              <p>
                <strong>Complaints:</strong> The Complaint Assistance Unit of the Division of Consumer Services of the California Department of Consumer Affairs 
                may be contacted in writing at 400 R Street, Suite 1080, Sacramento, CA 95814, or by telephone at (916) 445-1254 or (800) 952-5210.
              </p>
            </div>
          </div>
      </section>

      <Footer />
      <Gotop />
    </>
  );
}

export default Termsofuse;
